import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { Card } from 'antd';
import Icon from '../components/customIcons/customIcons';
import { DEFAULT_IMAGE_CARD, SELLER_TYPE } from '../config/Config';
import { STATUS_CODES } from '../config/StatusCode';
import { langs } from '../config/localization';
import {
  loadingAction,
  
  openLoginModel,
  setFavoriteItemId,
  markBookingFavoriteAction,
  removeToFavorite,
} from '../store/actions/index';
import {
  getBookingSubCatDetailRoute,
  getDetailPageRoute,
} from '../common/getRoutes';
import { capitalizeFirstLetter } from '../components/common';
import { ReactComponent as RatingStarIcon } from '../assets/images/new-images/rating-star.svg';
import { replaceImageURL } from '../common/Navigation';
class DetailCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_favourite: false,
    };
  }

  /**
   * @method componentDidMount 
   * @description called before mounting the component
   */
  componentDidMount() {
    const { data } = this.props;
    this.setState({ is_favourite: data.is_favourite === 1 ? true : false });
  }

  /**
   * @method onSelection
   * @description mark favorite unfavorite
   */
  onSelection = (data) => {
    const { isLoggedIn, loggedInDetail } = this.props;
    const { is_favourite } = this.state;
    if (isLoggedIn) {
      if (data.is_favourite === 1 || is_favourite) {
        const requestData = {
          user_id: loggedInDetail.id,
          item_id: data.id,
        };
        this.props.loadingAction(true);
        this.props.removeToFavorite(requestData, (res) => {
          this.props.loadingAction(false);
          if (res.status === STATUS_CODES.OK) {
            toastr.success(langs.success, res.data.message);
            this.setState({ is_favourite: false });
          }
        });
      } else {
        const requestData = {
          user_id: loggedInDetail.id,
          item_type: 'business',
          item_id: data.id,
          category_id: data?.business_profile?.booking_cat_id ?? 0,
          sub_category_id: data?.business_profile?.booking_sub_cat_id ?? 0,
        };
        this.props.loadingAction(true);
        this.props.markBookingFavoriteAction(requestData, (res) => {
          this.props.loadingAction(false);
          if (res.success) {
            toastr.success(langs.success, res.message);
            this.setState({ is_favourite: true });
            // this.props.callNext()
          }
        });
      }
    } else {
      this.props.openLoginModel();
    }
  };

  /**
   * @method render
   * @description render component
   */
  render() {
    const { data } = this.props;
    const { is_favourite } = this.state;
    if (data?.business_profile?.sub_category) {
      const { business_profile, seller_type } = data
      const { name, id } = business_profile?.sub_category
      let subCategoryName = name;
      let path =  getDetailPageRoute(seller_type, subCategoryName, data.id, id);
      return (
        <div className='productItem'>
          <Card
            bordered={false}
            className={''}
            cover={
              <>
                <Link to={path}>
                  <img
                    src={data && data.image ? replaceImageURL(data?.image, 300, 300) : DEFAULT_IMAGE_CARD}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = DEFAULT_IMAGE_CARD;
                    }}
                    style={{ cursor: 'pointer' }}
                    alt={data && data.title !== undefined ? data.title : ''}
                  />
                </Link>

                {
                  this.props.page === 'home' ?
                    <>
                      <div className='productCart'>
                        <Icon
                          icon={is_favourite ? 'email' : 'cart'}
                          size='20'
                          onClick={() => this.contactModal(data)}
                        />
                      </div>
                      <div className='productWishlist xyz'>
                        <Icon
                          icon={is_favourite ? 'wishlist-fill' : 'wishlist'}
                          className={is_favourite ? 'active' : ''}
                          size='20'
                          onClick={() => this.onSelection(data)}
                        />
                      </div>
                    </> : ''
                }
              </>
            }
          >
            <Link to={path}>
              <div
                className='title'
              >
                {business_profile && business_profile.business_name
                  ? capitalizeFirstLetter(business_profile.business_name)
                  : data?.name}
              </div>
            </Link>
            <Link to={path}>
              <div
                className='category-box'
              >

                <div
                  className='price-box'
                >
                  <div className='price'>
                    {business_profile && business_profile.rate_per_hour
                      ? `AU$${business_profile.rate_per_hour}`
                      : ''}
                  </div>
                </div>

                <div className='rate-section'>
                  {/* <RatingStarIcon /> */}
                  {data.average_rating ? (
                    <>
                      <RatingStarIcon />
                      {`${parseInt(data.average_rating)}.0`}
                    </>
                  ) : (
                    'No reviews'
                  )}
                </div>


                <div className='rate-section'>
                  {subCategoryName}
                </div>
              </div>
            </Link>
          </Card>
        </div>
      );

    } else {
      return <></>
    }
  }
}

const mapStateToProps = (store) => {
  const { auth, common } = store;
  const { isOpenLoginModel, favoriteId } = common;
  return {
    isLoggedIn: auth.isLoggedIn,
    loggedInDetail: auth.loggedInUser,
    isOpenLoginModel,
    favoriteId,
  };
};

export default connect(mapStateToProps, {
  loadingAction,  
  openLoginModel,
  setFavoriteItemId,
  markBookingFavoriteAction,
  removeToFavorite,
})(withRouter(DetailCard));
